export enum HttpErrorType {
    E401 = 1
}

export class HttpErrorInfo {
    message: string;
    type: HttpErrorType;
}